import { TypedDocumentNode, gql } from '@apollo/client';

import {
  CardPaymentMerchantEnum,
  CardTransactionTypeEnum,
} from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { GetCardTransactionsInfoForUserRes } from './getCardTransactionsInfoForUser';

type GetCardTransactionsInfoForUserArgs = {
  type: CardTransactionTypeEnum;
  merchant?: CardPaymentMerchantEnum;
  isCardAdd?: boolean;
};

export const getCardTransactionsInfoForUserNewQuery: TypedDocumentNode<
  DefaultApiResponse<GetCardTransactionsInfoForUserRes>,
  DefaultArg<GetCardTransactionsInfoForUserArgs>
> = gql`
  query getCardTransactionsInfoForUser(
    $record: GetCardTransactionsInfoForUserRecord!
  ) {
    getCardTransactionsInfoForUser: getCardTransactionsInfoForUserNew(
      record: $record
    ) {
      cardTransactionAllowed
      cardTransactionEnableDate
      cardAddAllowed
      cardDepositAllowed
      timeAmount
      timeUnit
    }
  }
`;
